import React, { useState, useEffect } from 'react';

function CookieModal({ categories, cookieOptions, onToggle, onSave, onAcceptAll, onRejectAll, onClose }) {
  const [expandedIndex, setExpandedIndex] = useState(0);

  // Modal açıkken body scroll'u kilitle
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  // ESC tuşuyla kapatma
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  const toggleAccordion = (index) => {
    setExpandedIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <div className="cookie-modal-overlay" onClick={onClose}>
      <div className="cookie-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="cookie-modal__header">
          <div className="cookie-modal__header-content">
            <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22" style={{ color: '#fff' }}>
              <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-.34-.02-.675-.057-1.006a4.001 4.001 0 0 1-3.937-3.937A10.052 10.052 0 0 0 12 2zm-1.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-3 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" />
            </svg>
            <span className="cookie-modal__title">Çerez Yönetimi</span>
          </div>
          <button className="cookie-modal__close-btn" onClick={onClose} aria-label="Kapat" type="button">
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="cookie-modal__body">
          <p className="cookie-modal__description">
      İnternet Sitesi’nin sağlanması ve bilgi toplumu hizmetlerinin sunulması için zorunlu çerezler kullanmaktayız. Ayrıca, İnternet Sitesi’ni daha işlevsel kullanabilmeniz ve deneyiminizin iyileştirilmesi kapsamında performans ve analitik çerezleri, size yönelik kişiselleştirilmiş ürün ve hizmet tanıtımı kapsamında ise reklam ve pazarlama çerezleri kullanılmak istenmektedir. Zorunlu olmayan çerezler onay vermediğiniz durumlarda kullanılmayacaktır.
          </p>

          {/* Accordion */}
          <div className="cookie-modal__accordion">
            {categories
              .filter((cat) => cat.id !== 'banner')
              .map((category, index) => {
                const isExpanded = expandedIndex === index;

                return (
                  <div
                    key={category.id}
                    className={`cookie-modal__accordion-item ${isExpanded ? 'is-expanded' : ''}`}
                  >
                    <button
                      className="cookie-modal__accordion-header"
                      onClick={() => toggleAccordion(index)}
                      type="button"
                      aria-expanded={isExpanded}
                    >
                      <div className="cookie-modal__accordion-left">
                        <div
                          className={`cookie-modal__accordion-icon-wrap ${isExpanded ? 'is-expanded' : ''}`}
                        >
                          {isExpanded ? (
                            <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                              <path d="M19 13H5v-2h14v2z" />
                            </svg>
                          ) : (
                            <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                            </svg>
                          )}
                        </div>
                        <span className="cookie-modal__accordion-name">{category.name}</span>
                      </div>

                      {/* Toggle Switch */}
                      <label className="cookie-toggle" onClick={(e) => e.stopPropagation()}>
                        <input
                          className="cookie-toggle__input"
                          type="checkbox"
                          checked={!!cookieOptions[category.id]}
                          disabled={category.required}
                          onChange={() => onToggle(category.id)}
                          aria-label={category.name}
                        />
                        <span className="cookie-toggle__slider" />
                      </label>
                    </button>

                    <div className={`cookie-modal__accordion-panel ${isExpanded ? 'is-expanded' : ''}`}>
                      <p
                        className="cookie-modal__accordion-text"
                        dangerouslySetInnerHTML={{ __html: category.description }}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        {/* Footer */}
        <div className="cookie-modal__footer">
          <div className="cookie-modal__footer-actions">
            <button className="cookie-modal__btn cookie-modal__btn--primary" onClick={onSave} type="button">
              Ayarları Kaydet
            </button>
            <button className="cookie-modal__btn cookie-modal__btn--outline" onClick={onRejectAll} type="button">
              Tümünü Reddet
            </button>
            <button className="cookie-modal__btn cookie-modal__btn--outline" onClick={onAcceptAll} type="button">
              Tümünü Kabul Et
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieModal;
